import QuoteList from './QuoteList'


export default QuoteList
